import { fetchDrawerData } from '../API/fetchDrawerData';
import { addItem } from './itemReducer/actions';
import { setUnreadCount } from './countReducer/actions';

export const loadDrawerData = (source, timestamp) => (dispatch) =>
    fetchDrawerData({ source, timestamp }).then((res) => {
        const items = res[source] || [];
        const unreadCount = res[`unread_${source}_count`] || 0;

        items.forEach((item) => {
            dispatch(addItem(source, item));
        });

        dispatch(setUnreadCount(source, unreadCount));
    });

export const ACTION_TYPE_MONITOR = 'ACTION_TYPE_MONITOR';

export const monitor = (source, ...label) => ({
    type: ACTION_TYPE_MONITOR,
    label: ['NotificationsDrawer', source, ...label].filter(Boolean).join('.'),
});
